import Swiper from 'swiper';
// import {Autoplay} from 'swiper/modules';

export function imageCardsSwiper() {
    const carousels = document.querySelectorAll('.image-cards-carousel');

    function updateButtonColor(carousel, selector, color) {
        const buttons = carousel.querySelectorAll(selector);
        if (buttons) {
            buttons.forEach((button) => {
                button.style.fill = color;
            });
        }
    }

    function setButtonDisabled(carousel, selector, setDisabled) {
        const buttons = carousel.querySelectorAll(selector);
        if (buttons) {
            buttons.forEach((button) => {
                if (setDisabled) {
                    button.setAttribute('disabled', '');
                } else {
                    button.removeAttribute('disabled');
                }
            });
        }
    }

    /**
     * Determine the value for `slidesPerView` for each breakpoint.
     *
     * There are some specific rules for this value depending on
     * how many cards can be displayed at one time and how Swiper.js
     * calculates width and spacing.
     *
     * @param {Integer} totalSlideCount
     * The total number of slides in the slider
     *
     * @param {Integer} breakpointWidth
     * The viewport size to set the slidesPerView value for
     *
     * @returns Number
     */
    function getSlidesPerBreakpoint(totalSlideCount, breakpointWidth) {
        let slidesPerView = 1.2;

        switch (breakpointWidth) {
            case 569:
                slidesPerView = 2.3;

                if (totalSlideCount === 2) {
                    slidesPerView = 1.5;
                }
                break;

            case 841:
                slidesPerView = 2.5;

                if (totalSlideCount === 2) {
                    slidesPerView = 2;
                }
                break;

            case 1200:
                slidesPerView = 2.5;

                if (totalSlideCount === 2) {
                    slidesPerView = 2;
                }
                break;

            case 1500:
                slidesPerView = 3.3;

                if (totalSlideCount <= 3) {
                    slidesPerView = totalSlideCount;
                }
                break;

            case 1921:
                slidesPerView = 3.8;

                if (totalSlideCount <= 3) {
                    slidesPerView = totalSlideCount;
                }

                if (totalSlideCount === 4) {
                    slidesPerView = 3.5;
                }
                break;

            case 2560:
                slidesPerView = 3.8;

                if (totalSlideCount <= 3) {
                    slidesPerView = totalSlideCount;
                }

                if (totalSlideCount === 4) {
                    slidesPerView = 3.5;
                }
                break;

            case 2880:
                slidesPerView = 4.3;

                if (totalSlideCount <= 4) {
                    slidesPerView = totalSlideCount;
                }
                break;

            case 3440:
                slidesPerView = 4.5;

                if (totalSlideCount <= 4) {
                    slidesPerView = totalSlideCount;
                }
                break;
            default:
                break;
        }

        return slidesPerView;
    }

    // Loop through each carousel and initialize Swiper
    carousels.forEach((carousel) => {
        const carouselWrapper = carousel.querySelector('.swiper.cards-carousel');
        const isAutoplayEnabled = carousel.classList.contains('autoplay-enabled');
        const slides = carousel.querySelectorAll('.swiper-slide');
        const slidesCount = slides.length;

        const swiperPrev = carousel.querySelectorAll('.swiper-button-prev');
        const swiperNext = carousel.querySelectorAll('.swiper-button-next');

        // CSS to hide the arrows when data-total-slides = 3 for breakpoint md
        carousel.setAttribute('data-total-slides', slides.length);

        if (slidesCount >= 2) {
            const swiper = new Swiper(carouselWrapper, {
                autoplay: isAutoplayEnabled
                    ? {
                          delay: 5000,
                      }
                    : false,
                direction: 'horizontal',
                a11y: {
                    slideRole: '',
                },
                loop: false,
                slidesPerView: 1.2,
                spaceBetween: 16,
                breakpoints: {
                    569: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 569),
                        spaceBetween: 16,
                        preventInteractionOnTransition: true,
                    },
                    841: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 841),
                        spaceBetween: 16,
                    },
                    1200: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 1200),
                        spaceBetween: 20,
                    },
                    1500: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 1500),
                        spaceBetween: 24,
                    },
                    1921: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 1921),
                        spaceBetween: 40,
                    },
                    2560: {
                        // WQXGA / UWFHD / QHD
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 2560),
                        spaceBetween: 40,
                    },
                    2880: {
                        // WQXGA+
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 2880),
                        spaceBetween: 40,
                    },
                    3440: {
                        // UWQHD
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 3440),
                        spaceBetween: 40,
                    },
                },
                on: {
                    slideChange: function () {
                        const slidesPerView = this.params.slidesPerView;
                        const totalSlides = this.slides.length;

                        const isFirstSlide = this.activeIndex === 0 && !this.params.loop;
                        // Showing two cards at a time
                        const isLastSlide = this.activeIndex >= totalSlides - slidesPerView && !this.params.loop;

                        if (carousel.dataset.mode && carousel.dataset.mode.match(/dark/i)) {
                            updateButtonColor(carousel, '.swiper-button-prev svg path', isFirstSlide ? '#B9BDC8' : '#fff');
                            updateButtonColor(carousel, '.swiper-button-next svg path', isLastSlide ? '#B9BDC8' : '#fff');
                        } else {
                            updateButtonColor(carousel, '.swiper-button-prev svg path', isFirstSlide ? '#b9bdc8' : '#060D32');
                            updateButtonColor(carousel, '.swiper-button-next svg path', isLastSlide ? '#b9bdc8' : '#060D32');
                        }

                        if (isFirstSlide) {
                            setButtonDisabled(carousel, '.swiper-button-prev', true);
                        } else {
                            setButtonDisabled(carousel, '.swiper-button-prev', false);
                        }

                        if (isLastSlide) {
                            setButtonDisabled(carousel, '.swiper-button-next', true);
                        } else {
                            setButtonDisabled(carousel, '.swiper-button-next', false);
                        }
                    },
                    reachEnd: function () {
                        swiperNext.forEach((next) => {
                            next.setAttribute('disabled', '');
                            next.querySelector('.swiper-button-next svg path').style.fill = '#b9bdc8';
                        });
                    },
                },
            });

            const prevButtonPaths = carousel.querySelectorAll('.swiper-button-prev svg path');
            const nextButtonPaths = carousel.querySelectorAll('.swiper-button-next svg path');

            let prevColor;
            let nextColor;

            if (carousel.dataset.mode && carousel.dataset.mode.match(/dark/i)) {
                prevColor = swiper.realIndex === 0 && !swiper.params.loop ? '#B9BDC8' : '#fff';
                nextColor = swiper.realIndex === 0 && !swiper.params.loop && '#fff';
            } else {
                prevColor = swiper.realIndex === 0 && !swiper.params.loop ? '#b9bdc8' : '#060D32';
                nextColor = swiper.realIndex === 0 && !swiper.params.loop && '#060D32';
            }

            prevButtonPaths.forEach((path) => {
                path.style.fill = prevColor;
            });

            nextButtonPaths.forEach((path) => {
                path.style.fill = nextColor;
            });

            swiperPrev.forEach((prev) => {
                prev.addEventListener('mousedown', () => {
                    swiper.slidePrev();
                });
                prev.addEventListener('touch', () => {
                    swiper.slidePrev();
                });
                prev.addEventListener('keydown', (e) => {
                    if (e.code == 'Space' || e.code == 'Enter') {
                        e.preventDefault();
                        swiper.slidePrev();
                        // Focus on current slide
                        slides[swiper.activeIndex].querySelector('a').focus();
                    }
                });
            });

            swiperNext.forEach((next) => {
                next.addEventListener('mousedown', () => {
                    swiper.slideNext();
                });
                next.addEventListener('touch', () => {
                    swiper.slideNext();
                });
                next.addEventListener('keydown', (e) => {
                    if (e.code == 'Space' || e.code == 'Enter') {
                        e.preventDefault();
                        swiper.slideNext();
                        // Focus on current slide
                        slides[swiper.activeIndex].querySelector('a').focus();
                    }
                });
            });

            setButtonDisabled(carousel, '.swiper-button-prev', true);
        } else {
            carouselWrapper?.classList.add('orient--left');

            slides.forEach((slide) => {
                slide.classList.add('slide--single');
            });

            swiperPrev.forEach((prev) => {
                prev.style.display = 'none';
            });

            swiperNext.forEach((next) => {
                next.style.display = 'none';
            });
        }
    });
}
